import React from "react";

export default function ModernLoader({ size = 48, color = "#6C4DFF" }) {
  return (
    <div className="flex items-center justify-center w-full py-8">
      <span
        className="modern-dual-ring"
        style={{
          width: size,
          height: size,
          borderColor: `${color} transparent ${color} transparent`
        }}
      />
      <style>{`
        .modern-dual-ring {
          display: inline-block;
          border-radius: 50%;
          border: 4px solid;
          border-color: ${color} transparent ${color} transparent;
          animation: modern-dual-ring-spin 1.2s linear infinite;
        }
        @keyframes modern-dual-ring-spin {
          0% { transform: rotate(0deg);}
          100% { transform: rotate(360deg);}
        }
      `}</style>
    </div>
  );
} 